import React from "react";
import { FileText, Download, CircleAlert } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { mediaUrl } from "@/lib/api";
import { SectionLayout, SectionIntro, Panel } from "@/components/SectionLayout";

export const Documents = ({ data }) => {
  const { L, t } = useLang();
  if (!data) return null;

  return (
    <SectionLayout id="documents" icon={FileText}>
      <SectionIntro>{L(data.intro)}</SectionIntro>

      <div className="space-y-3">
        {(data.items || []).map((doc) => (
          <Panel key={doc.id} className="flex items-center gap-4" data-testid={`document-${doc.id}`}>
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-[#0A192F]/6 text-[#0A192F]">
              <FileText size={20} strokeWidth={1.6} />
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="font-display text-lg font-medium text-[#0A192F]">{L(doc.title)}</h3>
              <p className="truncate text-xs text-[#64748B]">{L(doc.status)}</p>
            </div>
            {doc.fileUrl ? (
              <a
                href={mediaUrl(doc.fileUrl)}
                target="_blank"
                rel="noreferrer"
                className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-[#D4AF37] px-4 py-2 text-sm font-semibold text-[#0A1128]"
              >
                <Download size={14} /> {t("download")}
              </a>
            ) : (
              <span className="shrink-0 rounded-full bg-[#F1F5F9] px-3 py-1.5 text-xs text-[#64748B]">
                {t("noFileYet")}
              </span>
            )}
          </Panel>
        ))}
      </div>

      {Array.isArray(data.reminders) && data.reminders.length > 0 && (
        <>
          <h2 className="mb-3 mt-8 font-display text-2xl font-medium text-[#0A192F]">{t("documents.reminders")}</h2>
          <Panel className="bg-gradient-to-br from-[#FBF3D8] to-white">
            <ul className="space-y-2.5">
              {data.reminders.map((r, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm font-light text-[#0A1128]/80">
                  <CircleAlert size={16} className="mt-0.5 shrink-0 text-[#D4AF37]" />
                  {L(r)}
                </li>
              ))}
            </ul>
          </Panel>
        </>
      )}
    </SectionLayout>
  );
};
